// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"fe0d1596","339":"26608b7c","398":"da4f6ef9","536":"679b0e2d","647":"2bc3e676","720":"0fb0499d","878":"940b1550","988":"b6063b8f"}[chunkId] + ".chunk.js";
};